(function () {
  var ATTR_OPEN = 'data-crisp-chat-open';

  function crispPush(args) {
    if (!window.$crisp || typeof window.$crisp.push !== 'function') return false;
    window.$crisp.push(args);
    return true;
  }

  function setTriggersExpanded(opened) {
    document.querySelectorAll('[data-open-crisp-chat]').forEach(function (el) {
      el.setAttribute('aria-expanded', opened ? 'true' : 'false');
    });
  }

  function closeSamplesDropdown() {
    document.dispatchEvent(new CustomEvent('header:close-samples-menu'));
  }

  /**
   * Fully hide the widget (no bubble). Runtime only; see Crisp chat:hide docs.
   */
  function hideWidget() {
    document.documentElement.removeAttribute(ATTR_OPEN);
    setTriggersExpanded(false);
    crispPush(['do', 'chat:hide']);
  }

  /**
   * After chat:hide, chat:open alone often does nothing — must chat:show first.
   * @see https://help.crisp.chat/en/article/how-to-programmatically-hide-and-show-the-chatbox-13l0f8e/
   */
  function openChatViaCrisp() {
    crispPush(['do', 'chat:show']);
    crispPush(['do', 'chat:open']);
  }

  function showWidget() {
    closeSamplesDropdown();
    document.documentElement.setAttribute(ATTR_OPEN, 'true');
    setTriggersExpanded(true);

    function attempt(left) {
      if (window.$crisp && typeof window.$crisp.push === 'function') {
        openChatViaCrisp();
        return;
      }
      if (left <= 0) return;
      window.setTimeout(function () {
        attempt(left - 1);
      }, 100);
    }

    attempt(60);
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('[data-open-crisp-chat]');
      if (!trigger) return;
      e.preventDefault();
      showWidget();
    },
    true
  );

  document.addEventListener('header:close-crisp-chat', hideWidget);

  function attachCrispHooks() {
    crispPush([
      'on',
      'chat:opened',
      function () {
        closeSamplesDropdown();
        document.documentElement.setAttribute(ATTR_OPEN, 'true');
        setTriggersExpanded(true);
      },
    ]);

    crispPush([
      'on',
      'chat:closed',
      function () {
        hideWidget();
      },
    ]);

    hideWidget();
  }

  if (window.$crisp && typeof window.$crisp.push === 'function') {
    attachCrispHooks();
  } else {
    var remaining = 375;
    var timer = window.setInterval(function () {
      remaining -= 1;
      if (window.$crisp && typeof window.$crisp.push === 'function') {
        window.clearInterval(timer);
        attachCrispHooks();
      } else if (remaining <= 0) {
        window.clearInterval(timer);
      }
    }, 80);
  }
})();
